require('sass/brands/branches.nationwide.co.uk/search/default.scss');
require('js/search-script.js');
